<ax-text-box (textChange)="handleValueChange($event)" [text]="value">
    <ax-button *ngIf="allowHtml" (onClick)="handleShowEditor()">
        EDIT
    </ax-button>
</ax-text-box>